import type { ServicePage } from "./types";

export const automotivoPages: ServicePage[] = [
  {
    slug: "chaveiro-automotivo",
    keyword: "chaveiro automotivo",
    title: "Chaveiro Automotivo | Chaves Codificadas | Chavel Betim",
    description:
      "Chaveiro automotivo: abertura de veículo, chave codificada, telecomando e reparo de canhão de ignição. Atendimento em Betim - (31) 3531-3544.",
    h1: "Chaveiro automotivo: chaves, controles e abertura de veículos",
    lead: "Carro moderno não tem mais chave simples. Há transponder, telecomando, chave canivete e chave presencial — e cada tipo exige equipamento de programação específico.",
    category: "automotivo",
    quickAnswer:
      "Chaveiro automotivo é o profissional que abre veículos trancados, faz e programa chaves codificadas, copia telecomandos e repara canhões de ignição. Em Betim, a Chavel atende pelo WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Tipos de chave de carro",
        paragraphs: [
          "Identificar o tipo de chave é o primeiro passo para saber prazo e preço do serviço.",
        ],
        h3: [
          { title: "Chave simples", text: "Sem eletrônica, comum em veículos mais antigos. Cópia rápida e barata." },
          { title: "Chave com transponder", text: "Tem um chip que dialoga com o imobilizador do carro. Precisa ser codificada para dar partida." },
          { title: "Chave canivete", text: "Lâmina retrátil com telecomando embutido. Exige corte da lâmina e programação do controle." },
          { title: "Chave presencial", text: "Sistema keyless com botão de partida. Programação exige equipamento e, às vezes, senha do fabricante." },
        ],
      },
      {
        h2: "Abertura de veículo sem danos",
        paragraphs: [
          "A abertura é feita com ferramentas de tração e hastes específicas que atuam na trava sem forçar vidro, borracha ou lataria. Cabides e cunhas improvisadas amassam a porta e podem romper o cabo da trava elétrica.",
        ],
      },
      {
        h2: "Perdi a única chave do carro. E agora?",
        paragraphs: [
          "É resolvível. O chaveiro automotivo lê o código do veículo, confecciona a nova chave, corta a lâmina e programa o chip no imobilizador. É necessário comprovar a propriedade com documento do veículo e identidade.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês fazem chave de qualquer marca?",
        a: "Atendemos a maioria das marcas nacionais e importadas. Envie marca, modelo e ano pelo WhatsApp para confirmarmos.",
      },
      {
        q: "Quanto tempo demora para fazer uma chave codificada?",
        a: "Na maioria dos modelos, entre 30 minutos e 1 hora. Modelos com senha de fabricante podem demorar mais.",
      },
      {
        q: "Preciso levar o carro até a loja?",
        a: "Não necessariamente. O serviço pode ser feito onde o veículo estiver, dentro de Betim.",
      },
    ],
    related: ["chaveiro-automotivo-betim", "chaveiros-de-carro", "chave-codificada", "fazer-copia-de-chave-codificada-preco"],
  },
  {
    slug: "chaveiro-automotivo-betim",
    keyword: "chaveiro automotivo betim",
    title: "Chaveiro Automotivo em Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro automotivo em Betim: abertura de carro, chave codificada, chave canivete e telecomando. Av. Amazonas, 1354 - Brasiléia.",
    h1: "Chaveiro automotivo em Betim",
    lead: "Betim tem trânsito pesado de veículos leves e pesados e uma frota grande de carros populares. A Chavel atende motoristas da cidade com chaves codificadas, abertura e reparo de ignição.",
    category: "automotivo",
    quickAnswer:
      "A Chavel é chaveiro automotivo em Betim, na Av. Amazonas, 1354 - Lj 01, Brasiléia. Faz abertura de veículos, chaves codificadas, chaves canivete, telecomandos e reparo de cilindro de ignição. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços automotivos disponíveis",
        paragraphs: [
          "O atendimento cobre desde a cópia adicional de chave até a situação em que não sobrou nenhuma chave do veículo.",
        ],
        bullets: [
          "Abertura de veículo trancado, inclusive com o motor ligado",
          "Confecção de chave codificada por perda total",
          "Cópia adicional de chave com transponder",
          "Conserto e substituição de chave canivete",
          "Programação e clonagem de telecomando",
          "Reparo de canhão de ignição e cilindro de porta",
        ],
      },
      {
        h2: "Onde atendemos em Betim",
        paragraphs: [
          "Fazemos atendimento em casa, no trabalho, em estacionamentos e nas vias da cidade — Av. Amazonas, Centro, MG-050, distritos industriais e bairros residenciais.",
        ],
      },
      {
        h2: "Documentos necessários",
        paragraphs: [
          "Para confecção de chave, é obrigatório apresentar o documento do veículo (CRLV) e um documento com foto do proprietário ou autorização. Essa exigência protege você contra furto de veículo.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês fazem chave de moto?",
        a: "Sim, incluindo modelos com chip e chave de baú.",
      },
      {
        q: "Trabalham com veículos utilitários e caminhões?",
        a: "Sim, atendemos frotas e veículos pesados que circulam em Betim.",
      },
      {
        q: "A chave nova apaga a antiga?",
        a: "Em alguns modelos é possível apagar as chaves anteriores da memória do imobilizador — recomendado quando houve perda ou furto.",
      },
    ],
    related: ["chaveiro-automotivo", "chaveiros-de-carro", "chave-codificada", "chaveiro-betim"],
  },
  {
    slug: "chaveiros-de-carro",
    keyword: "chaveiros de carro",
    title: "Chaveiros de Carro em Betim | Cópia e Programação | Chavel",
    description:
      "Chaveiros de carro em Betim: cópia, programação, chave canivete, capa e reparo. Orçamento no WhatsApp (31) 3531-3544.",
    h1: "Chaveiros de carro: cópia, reparo e substituição",
    lead: "Chave de carro é peça de desgaste. Botão que não responde, lâmina torta, capa quebrada e bateria fraca são problemas com solução simples quando tratados antes da falha total.",
    category: "automotivo",
    quickAnswer:
      "Em Betim, a Chavel faz cópia de chaves de carro, troca de capa e lâmina, substituição de bateria, reparo de telecomando e programação de chave nova. Endereço: Av. Amazonas, 1354 - Brasiléia. WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Sinais de que a chave vai falhar",
        paragraphs: [
          "Antes de parar de vez, a chave dá avisos. Ignorá-los é o caminho mais rápido para ficar a pé.",
        ],
        bullets: [
          "Botão precisa ser apertado várias vezes ou muito perto do carro",
          "Lâmina entra na ignição com dificuldade ou está visivelmente torta",
          "Capa rachada deixando a placa eletrônica exposta",
          "Carro só dá partida com a chave em posição específica",
        ],
      },
      {
        h2: "Vale a pena ter chave reserva?",
        paragraphs: [
          "Sim, e é a decisão mais econômica. Fazer uma cópia enquanto ainda existe uma chave funcionando custa consideravelmente menos do que a confecção por perda total, que exige leitura direta do módulo do veículo.",
        ],
      },
      {
        h2: "Reparo x substituição",
        paragraphs: [
          "Se a eletrônica está boa e apenas a carcaça quebrou, a troca de capa resolve por uma fração do preço. Placa danificada por água ou queda geralmente pede chave nova.",
        ],
      },
    ],
    faq: [
      {
        q: "Consigo trocar só a capa da chave?",
        a: "Sim. Transferimos a placa eletrônica e a lâmina para a capa nova.",
      },
      {
        q: "Vocês trocam bateria de chave na hora?",
        a: "Sim, na loja da Av. Amazonas, 1354, em poucos minutos.",
      },
      {
        q: "A cópia funciona igual à original?",
        a: "Sim, quando programada corretamente ela aciona travas e partida da mesma forma.",
      },
    ],
    related: ["chaveiro-automotivo", "chave-codificada", "chaveiro-automotivo-betim", "fazer-copia-de-chave-codificada-preco"],
  },
  {
    slug: "chave-codificada",
    keyword: "chave codificada",
    title: "Chave Codificada em Betim | Programação | Chavel",
    description:
      "Chave codificada em Betim: confecção, programação de transponder e cópia. Atendimento no local pela Chavel — (31) 3531-3544.",
    h1: "Chave codificada: como funciona e quando fazer",
    lead: "Chave codificada é a chave que carrega um chip transponder reconhecido pelo imobilizador do veículo. Sem esse diálogo eletrônico, o motor não dá partida mesmo que a lâmina gire.",
    category: "automotivo",
    quickAnswer:
      "Chave codificada é a chave automotiva com chip transponder programado para o imobilizador do carro. Em Betim, a Chavel confecciona e programa chaves codificadas com atendimento no local — (31) 3531-3544.",
    sections: [
      {
        h2: "Como o sistema funciona",
        paragraphs: [
          "Ao girar a ignição, uma antena ao redor do cilindro energiza o chip da chave, que responde com um código. Se o código bate com o registrado no módulo, a injeção é liberada. É por isso que uma cópia apenas cortada não dá partida.",
        ],
      },
      {
        h2: "Etapas da confecção",
        paragraphs: [
          "O processo é técnico e exige equipamento de diagnóstico.",
        ],
        bullets: [
          "Identificação do veículo, do tipo de chip e do sistema de imobilizador",
          "Corte da lâmina conforme o segredo do veículo",
          "Gravação do transponder",
          "Programação no módulo do carro e teste de partida",
          "Quando necessário, exclusão de chaves antigas da memória",
        ],
      },
      {
        h2: "Chave codificada x chave comum",
        paragraphs: [
          "A chave comum abre a porta e gira a ignição, mas não libera a partida em veículos com imobilizador. Muitos clientes descobrem isso ao comprar cópia barata em quiosque: a porta abre, o carro não liga.",
        ],
      },
    ],
    faq: [
      {
        q: "Quanto custa uma chave codificada?",
        a: "Depende do modelo, do tipo de chip e se ainda existe uma chave funcionando. Envie marca, modelo e ano pelo WhatsApp para orçamento.",
      },
      {
        q: "Dá para codificar chave comprada na internet?",
        a: "Em muitos casos sim, desde que a peça seja compatível. Não nos responsabilizamos pela qualidade de peças de terceiros.",
      },
      {
        q: "Preciso levar o carro?",
        a: "A programação precisa ser feita com o veículo presente, mas vamos até ele em Betim.",
      },
    ],
    related: ["fazer-copia-de-chave-codificada-preco", "chaveiro-automotivo", "chaveiros-de-carro", "chaveiro-automotivo-betim"],
  },
  {
    slug: "fazer-copia-de-chave-codificada-preco",
    keyword: "fazer cópia de chave codificada preço",
    title: "Fazer Cópia de Chave Codificada: Preço em Betim | Chavel",
    description:
      "Quanto custa fazer cópia de chave codificada? Entenda o que define o preço em Betim e peça orçamento na Chavel — (31) 3531-3544.",
    h1: "Fazer cópia de chave codificada: preço e o que influencia",
    lead: "Não existe preço único para chave codificada. O valor muda com o tipo de chip, o sistema do veículo e se ainda há uma chave original funcionando.",
    category: "automotivo",
    quickAnswer:
      "O preço da cópia de chave codificada varia conforme marca, modelo, ano, tipo de transponder e se existe chave original. Cópia com chave existente é mais barata que confecção por perda total. Orçamento gratuito pela Chavel em Betim: (31) 3531-3544.",
    sections: [
      {
        h2: "O que entra no preço",
        paragraphs: [
          "Entender os componentes do orçamento evita comparação injusta entre serviços diferentes.",
        ],
        bullets: [
          "Custo da chave virgem ou telecomando compatível com o modelo",
          "Tipo de transponder e necessidade de senha do fabricante",
          "Corte da lâmina (mecânico ou laser, que é mais caro)",
          "Programação no módulo e tempo de equipamento",
          "Existência ou não de chave original funcionando",
          "Deslocamento, quando o serviço é feito fora da loja",
        ],
      },
      {
        h2: "Cópia x perda total",
        paragraphs: [
          "Com uma chave em mãos, o equipamento clona ou adiciona a nova rapidamente. Sem nenhuma chave, o profissional precisa acessar o módulo, ler ou calcular o código e, em alguns modelos, aguardar tempo de segurança imposto pelo fabricante. Por isso o segundo caso custa mais.",
        ],
      },
      {
        h2: "Como pedir orçamento certo em um minuto",
        paragraphs: [
          "Envie no WhatsApp: marca, modelo, ano, se a chave é canivete, presencial ou simples, e se ainda existe alguma chave funcionando. Com esses quatro dados conseguimos passar o valor sem você sair de casa.",
        ],
      },
    ],
    faq: [
      {
        q: "Chaveiro é mais barato que concessionária?",
        a: "Na maioria dos casos sim, com o mesmo resultado de programação e sem a espera por encomenda de peça.",
      },
      {
        q: "Vocês parcelam?",
        a: "Aceitamos cartão, Pix e dinheiro; o parcelamento depende do valor do serviço.",
      },
      {
        q: "O orçamento é gratuito?",
        a: "Sim, orçamento por WhatsApp é gratuito e sem compromisso.",
      },
    ],
    related: ["chave-codificada", "chaveiro-automotivo", "chaveiros-de-carro", "chaveiro-automotivo-betim"],
  },
];

export const bairroPages: ServicePage[] = [
  {
    slug: "chaveiro-alterosa-betim",
    keyword: "chaveiro alterosa betim",
    title: "Chaveiro no Alterosa, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Alterosa em Betim: abertura de porta, cópia de chaves, fechaduras e controles de portão. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro no bairro Alterosa, Betim",
    lead: "O Alterosa é um bairro residencial consolidado de Betim, com muitas casas de portão automático e fechaduras instaladas há anos. Os chamados mais frequentes refletem exatamente isso.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Alterosa, em Betim, com abertura de portas, troca de fechaduras, cópia de chaves e controles de portão. Loja na Av. Amazonas, 1354 - Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços mais pedidos no Alterosa",
        paragraphs: [
          "Em bairros com casas e sobrados, a demanda se concentra em portões, fechaduras externas e chaves de portão social.",
        ],
        bullets: [
          "Cópia e programação de controle de portão eletrônico",
          "Instalação de fechadura elétrica no portão social",
          "Troca de fechadura de porta de madeira desgastada",
          "Abertura de porta com chave esquecida dentro de casa",
        ],
      },
      {
        h2: "Manutenção preventiva em casas do Alterosa",
        paragraphs: [
          "Fechaduras externas sofrem com chuva e sol. Uma lubrificação com grafite a cada seis meses e o aperto das testas evitam o travamento repentino que gera chamado de emergência.",
        ],
      },
      {
        h2: "Tempo de atendimento",
        paragraphs: [
          "Do Brasiléia até o Alterosa o deslocamento é curto, o que permite atendimento no mesmo dia para a maioria dos chamados dentro do horário comercial.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês instalam fechadura digital no Alterosa?",
        a: "Sim, com visita para avaliar a porta e indicar o modelo adequado.",
      },
      {
        q: "Fazem cópia de controle de portão no local?",
        a: "Sim, quando o controle original está disponível para clonagem.",
      },
    ],
    related: ["controle-de-portao", "fechadura-eletrica-para-portao", "chaveiro-betim", "chaveiro-a-domicilio"],
  },
  {
    slug: "chaveiro-angola",
    keyword: "chaveiro angola",
    title: "Chaveiro no Angola, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Angola, Betim: abertura de apartamentos, fechaduras de condomínio e cópia de chaves. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro no bairro Angola, Betim",
    lead: "O Angola concentra prédios e conjuntos residenciais, e o chamado clássico é a porta de apartamento que fecha sozinha com a chave do lado de dentro.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Angola, em Betim, com abertura de portas de apartamento, troca de segredo, cópia de chaves e fechaduras de condomínio. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Chamados típicos em prédios do Angola",
        paragraphs: [
          "Portas de apartamento com fechadura de cilindro e trinco de mola batem com corrente de ar. Nesses casos a abertura costuma ser rápida e sem dano.",
        ],
        bullets: [
          "Abertura de porta batida com chave dentro",
          "Troca de cilindro após perda de chave",
          "Cópia de chave de portaria e área comum",
          "Fechaduras para porta corta-fogo e escada de emergência",
        ],
      },
      {
        h2: "Serviços para condomínios",
        paragraphs: [
          "Administradoras do Angola podem padronizar as chaves das áreas comuns em um sistema de chave mestra, no qual uma única chave do zelador abre vários pontos, sem que a chave do morador abra o que não deve.",
        ],
      },
      {
        h2: "Autorização em condomínio",
        paragraphs: [
          "Para abertura em prédios, pedimos confirmação com a portaria ou o síndico além do documento do morador. É um passo simples que protege todos os condôminos.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês fazem sistema de chave mestra?",
        a: "Sim, para condomínios e empresas em Betim.",
      },
      {
        q: "Atendem apartamento alugado?",
        a: "Sim, com comprovação de contrato de locação ou confirmação da administração.",
      },
    ],
    related: ["chaveiro-betim", "fechaduras-de-porta", "chaveiro-24-horas-betim", "chaveiro-guaruja"],
  },
  {
    slug: "chaveiro-guaruja",
    keyword: "chaveiro guarujá",
    title: "Chaveiro no Guarujá, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Guarujá em Betim: abertura de portas, fechaduras, chaves e controles. Atendimento a domicílio - (31) 3531-3544.",
    h1: "Chaveiro no bairro Guarujá, Betim",
    lead: "Casas e pequenos comércios dividem espaço no Guarujá, e o serviço de chavearia acompanha essa mistura: fechadura de loja pela manhã, portão residencial à tarde.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Guarujá, em Betim, com abertura de portas, instalação e troca de fechaduras, cópias de chave e controles de portão. WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Residências e comércio no Guarujá",
        paragraphs: [
          "Para comércio, priorizamos fechaduras de alta rotatividade e cadeados reforçados. Para residências, o foco é reforço da porta de entrada e automação do portão.",
        ],
        bullets: [
          "Fechadura tetra e reforço de porta de entrada",
          "Cadeado blindado para portas de aço de comércio",
          "Cópia de chaves para funcionários",
          "Controle e fechadura elétrica de portão",
        ],
      },
      {
        h2: "Reforço de segurança sem obra",
        paragraphs: [
          "Trocar o cilindro por um de segurança, instalar contra-testa reforçada e acrescentar um trinco auxiliar aumentam bastante a resistência da porta sem quebrar a alvenaria.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês atendem o Guarujá no mesmo dia?",
        a: "Na maioria dos casos sim, dentro do horário comercial.",
      },
      {
        q: "Trabalham com fechadura tetra?",
        a: "Sim, fornecemos, instalamos e fazemos cópia de chave tetra.",
      },
    ],
    related: ["chaveiro-angola", "fechaduras-de-porta", "chaveiro-betim", "controle-de-portao"],
  },
  {
    slug: "chaveiro-inga",
    keyword: "chaveiro ingá",
    title: "Chaveiro no Ingá, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Ingá em Betim: abertura de portas, troca de fechaduras e chaves codificadas. Chame no WhatsApp (31) 3531-3544.",
    h1: "Chaveiro no bairro Ingá, Betim",
    lead: "O Ingá é uma das regiões mais movimentadas de Betim, com comércio de rua e grande circulação de veículos — o que gera muitos chamados de abertura automotiva.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Ingá, em Betim, com abertura de veículos e portas, chaves codificadas, fechaduras e controles. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Abertura de veículos no Ingá",
        paragraphs: [
          "Estacionar rápido para resolver algo no comércio e trancar a chave dentro do carro é um clássico. A abertura é feita no local, com ferramenta que não marca a lataria.",
        ],
      },
      {
        h2: "Serviços de porta e fechadura",
        paragraphs: [
          "Para o comércio local atendemos troca de fechadura de porta de vidro, cadeados e barras antipânico; para residências, abertura, troca de segredo e reforço de porta.",
        ],
        bullets: [
          "Abertura de carro e residência",
          "Chave codificada e telecomando",
          "Fechadura para porta de vidro temperado",
          "Troca de segredo após perda de chaves",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês abrem carro no meio da rua?",
        a: "Sim, desde que haja segurança para o trabalho e você comprove ser o proprietário ou condutor autorizado.",
      },
      {
        q: "Quanto tempo leva a abertura de um carro?",
        a: "Normalmente entre 5 e 20 minutos, dependendo do modelo e do tipo de trava.",
      },
    ],
    related: ["chaveiro-automotivo-betim", "chaveiro-betim", "chaveiro-urgente", "chaveiro-dom-bosco"],
  },
  {
    slug: "chaveiro-dom-bosco",
    keyword: "chaveiro dom bosco",
    title: "Chaveiro no Dom Bosco, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Dom Bosco em Betim: abertura, fechaduras, portões e cópia de chaves. Atendimento a domicílio - (31) 3531-3544.",
    h1: "Chaveiro no bairro Dom Bosco, Betim",
    lead: "No Dom Bosco predominam residências com portão de garagem e portas de madeira maciça, dois pontos que concentram os chamados de chavearia do bairro.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Dom Bosco, em Betim, com abertura de portas, fechaduras para portas de madeira, fechadura elétrica de portão e cópia de controles. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Portas de madeira: cuidados específicos",
        paragraphs: [
          "Madeira trabalha com a umidade. Porta que arrasta e fechadura que só fecha com força indicam necessidade de ajuste de dobradiças e da contra-testa antes que o mecanismo quebre.",
        ],
        bullets: [
          "Ajuste de batente e contra-testa",
          "Troca de fechadura com furação compatível",
          "Reforço da região do segredo contra arrombamento",
        ],
      },
      {
        h2: "Portões e automação",
        paragraphs: [
          "Instalamos fechadura elétrica e fazemos cópia de controles para portões de garagem, além de orientar sobre o modelo compatível com o motor já instalado.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês consertam a porta ou só a fechadura?",
        a: "Fazemos ajustes de batente, contra-testa e dobradiça necessários para a fechadura funcionar corretamente.",
      },
      {
        q: "Fazem cópia de controle de qualquer marca?",
        a: "Copiamos a maioria dos controles de código fixo e rolling code compatíveis. Traga o controle original.",
      },
    ],
    related: ["fechadura-de-porta-madeira", "fechadura-eletrica-para-portao", "controle-de-portao", "chaveiro-betim"],
  },
  {
    slug: "chaveiro-brasileia",
    keyword: "chaveiro brasiléia",
    title: "Chaveiro no Brasiléia, Betim | Chavel na Av. Amazonas",
    description:
      "Chaveiro no bairro Brasiléia, Betim: a loja da Chavel fica na Av. Amazonas, 1354 - Lj 01. Cópia de chaves, fechaduras e abertura.",
    h1: "Chaveiro no bairro Brasiléia, Betim",
    lead: "O Brasiléia é a casa da Chavel. A loja fica na Av. Amazonas, 1354 - Lj 01, no Ed. Carino Saraiva, e é referência de chavearia no bairro há décadas.",
    category: "bairro",
    quickAnswer:
      "A Chavel é o chaveiro do bairro Brasiléia, em Betim, com loja na Av. Amazonas, 1354 - Lj 01, CEP 32600-324. Cópia de chaves na hora, fechaduras, controles e abertura. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços feitos na loja em minutos",
        paragraphs: [
          "Quem está no bairro resolve na hora, sem taxa de deslocamento.",
        ],
        bullets: [
          "Cópia de chave comum, tetra e de cadeado",
          "Clonagem de controle de portão",
          "Troca de bateria de chave e controle",
          "Venda de fechaduras, cadeados e acessórios",
          "Carimbos e chaveiros personalizados",
        ],
      },
      {
        h2: "Como chegar",
        paragraphs: [
          "Estamos sobre a Av. Amazonas, principal via de ligação do bairro com o Centro de Betim, com ponto de ônibus próximo e cerca de 3 minutos a pé de quem já está na região.",
        ],
      },
      {
        h2: "Horário de atendimento",
        paragraphs: [
          "Segunda a sexta das 08:00 às 18:00 e sábado das 08:00 às 13:00. Domingo fechado.",
        ],
      },
    ],
    faq: [
      {
        q: "Precisa agendar para copiar chave?",
        a: "Não. Chaves comuns são copiadas na hora, sem agendamento.",
      },
      {
        q: "Tem estacionamento na loja?",
        a: "Há vagas na via e nas ruas próximas à Av. Amazonas.",
      },
      {
        q: "Vocês vendem fechaduras na loja?",
        a: "Sim, com opções de fechaduras comuns, tetra, digitais e elétricas.",
      },
    ],
    related: ["chaveiro-betim", "chaveiro-betim-centro", "fechaduras-de-porta", "chaveiro-a-domicilio"],
  },
];
